import { combineReducers } from '@reduxjs/toolkit';
import loginReducer from './request/loginReducer';
import tokenReducer from './request/tokenReducer';
import commonReducer from './commonReducer';
import profileReducer from './profileReducer';
import recommendFlowReducer from './recommendFlowReducer';
import settingReducer from './admin/settingReducer';
import firebaseReducer from './firebaseReducer';

const rootReducer = combineReducers({

otp:loginReducer,
token:tokenReducer,
common:commonReducer,
profile:profileReducer,
recommendFlow:recommendFlowReducer,
setting:settingReducer,
firebase:firebaseReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
